import Auth from '../auth'
import api from '@/services/api'
import { apiErrorHandler } from '../utils/apiErrors'
// import { objectToSnakeCase } from '../utils'

const ANSWER_ENDPOINT = 'answers/'

// const USERS_IMAGE_ENDPOINT = `/${USERS_ENDPOINT}/profile_pic/`

export default class AnswerAPI {
  /**
   * Instantiate a new `AnswerAPI`
   * @param {class} cls - The class to use to create objects.
   */
  constructor(cls) {
    this.cls = cls
  }

  /**
   * Factory method to create a new instance of `AnswerAPI`.
   * @param {class} cls - The class to use to create objects.
   **/
  static create(cls) {
    return new AnswerAPI(cls)
  }

  /* Get the API Client. */
  get client() {
    return api.getApiClient()
  }

  create(answer) {
    const url = ANSWER_ENDPOINT
    const data = this.cls.toAPI(answer)

    return this.client
      .post(url, data)
      .then(response => response.data)
      .then(this.cls.fromAPI)
      .catch(apiErrorHandler({ apiName: 'Create answer API error' }))
  }

  update(answer, fields = [], excludeFields = []) {
    const url = `${ANSWER_ENDPOINT}${answer.id}/`
    let data = this.cls.toAPI(answer, fields, excludeFields)

    return this.client
      .patch(url, data)
      .then(response => response.data)
      .then(this.cls.fromAPI)
      .catch(apiErrorHandler({ apiName: 'Update answer API error' }))
  }

  /**
   * Get List of answers via the API.
   *
   * @param {object} pagination - Pagination parameters for the API.
   * @param {object} filters - Filter parameters for the API.
   *
   * @returns {Promise} - Contains the list of `answer` instances.
   */
  list({ filters = {} } = {}) {
    const authHeader = Auth.getAuthorizationHeader()
    const url = ANSWER_ENDPOINT
    const options = {
      headers: {
        ...authHeader,
      },
      params: {},
    }
    if (filters.project) {
      options.params.project = filters.project
    }

    return this.client
      .get(url, options)
      .then(response => response.data)
      .then(data => ({
        ...data,
        results: data.results.map(this.cls.fromAPI),
      }))
      .catch(apiErrorHandler({ apiName: 'answer API error' }))
  }
}
